/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Region_EuropeInputs */

const bn_region_europe = /** @type {(inputs: Region_EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ইউরোপ`)
};

const de_region_europe = /** @type {(inputs: Region_EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Europa`)
};

const el_region_europe = /** @type {(inputs: Region_EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ευρώπη`)
};

const en_region_europe = /** @type {(inputs: Region_EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Europe`)
};

const es_region_europe = /** @type {(inputs: Region_EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Europa`)
};

const fr_region_europe = /** @type {(inputs: Region_EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Europe`)
};

const hi_region_europe = /** @type {(inputs: Region_EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यूरोप`)
};

const hu_region_europe = /** @type {(inputs: Region_EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Európa`)
};

const id_region_europe = /** @type {(inputs: Region_EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eropa`)
};

const it_region_europe = /** @type {(inputs: Region_EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Europa`)
};

const ja_region_europe = /** @type {(inputs: Region_EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ヨーロッパ`)
};

const ko_region_europe = /** @type {(inputs: Region_EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`유럽`)
};

const nl_region_europe = /** @type {(inputs: Region_EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Europa`)
};

const pl_region_europe = /** @type {(inputs: Region_EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Europa`)
};

const pt_region_europe = /** @type {(inputs: Region_EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Europa`)
};

const ru_region_europe = /** @type {(inputs: Region_EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Европа`)
};

const sv_region_europe = /** @type {(inputs: Region_EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Europa`)
};

const tr_region_europe = /** @type {(inputs: Region_EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avrupa`)
};

const uk_region_europe = /** @type {(inputs: Region_EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Європа`)
};

const vi_region_europe = /** @type {(inputs: Region_EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Châu Âu`)
};

const zh_region_europe = /** @type {(inputs: Region_EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`欧洲`)
};

const zh_hant_region_europe = /** @type {(inputs: Region_EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`歐洲`)
};

/**
* | output |
* | --- |
* | "Europe" |
*
* @param {Region_EuropeInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const region_europe = /** @type {((inputs?: Region_EuropeInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Region_EuropeInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_region_europe(inputs)
	if (locale === "de") return de_region_europe(inputs)
	if (locale === "el") return el_region_europe(inputs)
	if (locale === "en") return en_region_europe(inputs)
	if (locale === "es") return es_region_europe(inputs)
	if (locale === "fr") return fr_region_europe(inputs)
	if (locale === "hi") return hi_region_europe(inputs)
	if (locale === "hu") return hu_region_europe(inputs)
	if (locale === "id") return id_region_europe(inputs)
	if (locale === "it") return it_region_europe(inputs)
	if (locale === "ja") return ja_region_europe(inputs)
	if (locale === "ko") return ko_region_europe(inputs)
	if (locale === "nl") return nl_region_europe(inputs)
	if (locale === "pl") return pl_region_europe(inputs)
	if (locale === "pt") return pt_region_europe(inputs)
	if (locale === "ru") return ru_region_europe(inputs)
	if (locale === "sv") return sv_region_europe(inputs)
	if (locale === "tr") return tr_region_europe(inputs)
	if (locale === "uk") return uk_region_europe(inputs)
	if (locale === "vi") return vi_region_europe(inputs)
	if (locale === "zh") return zh_region_europe(inputs)
	return zh_hant_region_europe(inputs)
});